export default __webpack_public_path__ + "static/media/unknown-light.5361110a.svg";